import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import styled from "styled-components";
import LandingConnector from "./Connector/LandingConnector";
import Dropdown from "../Generic/Dropdown";
import { get, getApi } from "../config/api";
import { errorNotification } from "../Generic/Notifications";
import Loader from "../Generic/Loader";
import xook from "../Assets/Xook.png";
import Card from "../Generic/Card";
import Button from "../Generic/Button";

const Page = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 0;
	overflow-x: hidden;
`;

const Div = styled.div`
	display: flex;
	width: ${(props) => props.width};
	height: ${(props) => props.height};
	flex-direction: ${(props) => props.flexDirection};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	border: ${(props) => props.border};
	border-radius: ${(props) => props.borderRadius};
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	color: ${(props) => props.color};
	background: ${(props) => props.background};
	&:hover {
		background: ${(props) => (props.hoverEffect ? "rgba(45,35,66,0.1)" : "")};
		transform: ${(props) => (props.hoverEffect ? "scale(1.01)" : "")};
		transition: 0.2s all ease-in-out;
	}
`;

const MachineSelect = (props) => {
	let navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [machines, setMachines] = useState();
	const dropList = machines?.length
		? machines.map((item) => ({ head: item._id, value: item._id }))
		: [];

	function selectMachine(id) {
		var machineData = machines.find((m) => m._id === id);
		if (machineData) {
			props.setMachineID(machineData);
			navigate(`/${id}`);
		}
	}

	async function getMachines() {
		setLoading(true);
		const response = await get({ url: "/v1/dashboard/restaurant/all" });
		setLoading(false);
		const { data, error } = response;
		if (data) {
			setMachines(data);
		}
		if (error) {
			errorNotification(error);
		}
	}

	function clearAllTimeouts() {
		props.setMachineID({ _id: "", name: "", kitchenId: "" });
		var id = window.setTimeout(function () {}, 0);

		while (id--) {
			window.clearTimeout(id); // will do nothing if no timeout with id is present
		}
	}

	useEffect(() => {
		clearAllTimeouts();
		getMachines();
	}, []);

	return (
		<Page>
			<Div jContent="center" alignItem="center" flexDirection="column">
				<img src={xook} alt="logo" style={{ height: "5.5rem" }} />
				<Div margin="1rem 0 0 0" fontSize="1.4rem">
					RESTO FROM THE FUTURE
				</Div>
			</Div>
			<Div
				margin="3rem 0 0 0"
				jContent="center"
				alignItem="center"
				width="100%"
				flexWrap="wrap">
				<Card
					margin="1rem"
					width="20rem"
					height="10rem"
					jContent="center"
					alignItem="center">
					<Div jContent="center" padding="1rem" width="100%">
						{!loading && dropList.length > 0 && (
							<Dropdown
								border="1px solid"
								boxShadow=""
								margin=""
								headerFontSize=""
								head="Select Machine"
								widthVal="20rem"
								optionsList={dropList}
								value={props.machineID}
								onChange={(id) => selectMachine(id)}
							/>
						)}
						{loading && (
							<Div
								width="100%"
								margin="1rem 0 0 0"
								alignItem="center"
								jContent="center">
								<Loader />
							</Div>
						)}
						{!loading && dropList.length === 0 && (
							<Div alignItem="center" flexDirection="column" height="100%">
								<Div fontSize="1.3rem">No Machines Found</Div>
								<Button
									margin="1rem 0 0 0"
									onClick={() => {
										getMachines();
									}}
									active>
									Retry
								</Button>
							</Div>
						)}
					</Div>
				</Card>
				<NavLink to={"/studio"}>
					<Card
						width="20rem"
						height="10rem"
						jContent="center"
						alignItem="center">
						<Div fontSize="2rem" margin="0.5rem 0 0 0">
							Studio
						</Div>
					</Card>
				</NavLink>
			</Div>
		</Page>
	);
};

export default LandingConnector(MachineSelect);
